<template>
  <div>
    <page-title title="Stations" />
    <b-row>
      <b-col>
        <filtered-table :settings="tableSettings">
        </filtered-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "StationList",
  props: {},
  data() {
    let base = this;
    return {
      tableSettings: {
        query: 'stations',
        newUrl: '/station/add',
        //defaultSortColumn: 'displayCity',
        columns: [
          {
            key: 'id',
            name: 'ID',
            alwaysLoad: true,
            visible: false,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'isActive',
            name: 'Active',
            visible: true,
            filter: 'select',
            selectOptions: [
              { value: null, text: '' },
              { value: 'true', text: 'Active' },
              { value: 'false', text: 'Inactive' }
            ],
            render: function (v) {
              return v ? 'Active' : 'Inactive';
            }
          },
          {
            key: 'name',
            name: 'Name',
            visible: true,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'name2',
            name: 'Name 2',
            visible: false,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'displayCity',
            name: 'Display City',
            visible: true,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'city',
            name: 'City',
            visible: false,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'state',
            name: 'State',
            visible: true,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'postalCode',
            name: 'Postal Code',
            visible: false,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'country',
            name: 'Country',
            visible: false,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'website',
            name: 'Website',
            visible: false,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'headName',
            name: 'Station Head',
            visible: false,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'headEmail',
            name: 'Station Head Email',
            visible: false,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'displayType',
            name: 'Display Type',
            visible: false,
            filter: 'select',
            selectOptions: [
              { value: null, text: '' },
              { value: 'INDIVIDUAL_ALLERGENS', text: 'Individual Allergens' },
              { value: 'COUNT_TOTALS', text: 'Count Totals' },
              { value: 'SEVERITY_LEVEL', text: 'Severity Level' },
              { value: 'COUNT_TOTALS_AND_SEVERITY_LEVEL', text: 'Count Totals and Severity Level' },
              { value: 'ALL', text: 'Individual Allergens, Count Totals, and Severity Level' }
            ]
          },
          {
            key: 'notes',
            name: 'Notes',
            visible: false
          }
        ],
        rowClicked: function (item, context) {
          context.$router.push('/station/' + item.id + '/edit')
        }
      }
    }
  },
  methods: {
  },
  mounted () {
  }
};
</script>